"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _ = require("lodash");
const Select_1 = require("./Select");
const LEVELS = _.chain({
    7: '1:50 000',
    8: '1:25 000',
    9: '1:10 000',
    10: '1:10 000',
    11: '1:10 000',
    12: '1:10 000'
}).mapValues((value, key) => `${key} - skan ${value}`).value();
class LayerSelector extends React.Component {
    constructor() {
        super();
        this.state = {
            source: undefined,
            z: 9
        };
    }
    handleChange(state) {
        this.setState(state, () => {
            this.props.onChange({
                source: _.defaultTo(this.state.source, _(this.props.layers).keys().head()),
                z: this.state.z
            });
        });
    }
    render() {
        return React.createElement("span", { className: "LayerSelector" },
            React.createElement(Select_1.Select, { values: _.mapValues(this.props.layers, v => v.label), value: this.state.source, onChange: (layer) => this.handleChange({ source: layer }) }),
            React.createElement(Select_1.Select, { values: LEVELS, value: String(this.state.z), onChange: (level) => this.handleChange({ z: Number(level) }) }));
    }
}
exports.LayerSelector = LayerSelector;



//////////////////
// WEBPACK FOOTER
// ./src/components/LayerSelector.tsx
// module id = 117
// module chunks = 0 1